import { cn } from "../utils";
import type { HTMLAttributes } from "react";

interface AnimatedIconProps extends HTMLAttributes<HTMLDivElement> {
  /** Animation variant */
  variant?: "rotate" | "bounce" | "pulse" | "spin" | "float" | "scale";
  /** Trigger animation on hover of parent */
  hoverOnly?: boolean;
}

const animationClasses = {
  rotate: "group-hover:rotate-12 transition-transform duration-300",
  bounce: "group-hover:animate-bounce",
  pulse: "group-hover:animate-pulse",
  spin: "group-hover:animate-spin",
  float: "animate-float",
  scale: "group-hover:scale-110 transition-transform duration-300",
};

/**
 * Wrapper component for animating icons on hover or continuously
 */
export function AnimatedIcon({
  children,
  variant = "scale",
  hoverOnly = true,
  className,
  ...props
}: AnimatedIconProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-center shrink-0",
        hoverOnly ? animationClasses[variant] : variant === "float" ? "animate-float" : animationClasses[variant],
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
